import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const radius = [8, 16, 24, 32] as const;

export type TRadius = typeof radius[number];

export type TRounderProps = {
    $radius: TRadius,
    $desktop?: never,
    $mobile?: never,
} | {
    $radius?: never,
    $desktop: TRadius,
    $mobile: TRadius,
}

export const getRadiusByIncomingProps = ({ $radius, $desktop, $mobile }: TRounderProps) => {
    if ($radius) {
        return css`border-radius: ${$radius}px`;
    } else {
        return css`
            border-radius: ${$mobile}px;

            @media (min-width: ${wideBreakpoints.mobile}) {
                border-radius: ${$desktop}px;
            }
        `;
    }
};

const RounderContainer = styled.div<TRounderProps>`
    ${getRadiusByIncomingProps};
    overflow: hidden;
`;

export const withRadius = <T extends object>(Component: (props: T) => JSX.Element, props: TRounderProps) => {
    return styled(Component)<T>`
        ${getRadiusByIncomingProps(props)};
        overflow: hidden;
    `;
};

export default RounderContainer;
